
















import UserRequired from "../UserRequired";
import {Component, Prop} from "vue-property-decorator";
import {
  DatasourceNames,
  datasourceSelectItems,
  NotificationConfig,
  NotificationSensor, NotificationSensorAndConfigId
} from "@/modules/notificationmodels";
import {Company} from "@/modules/models";

@Component
export default class NotificationConfigSensorAdd extends UserRequired {
  @Prop()
  config!: NotificationConfig;

  @Prop({default: false})
  value!: boolean;

  get opened() {
    return this.value;
  }
  set opened(v: boolean) {
    this.$emit("input", v);
  }

  datasources = datasourceSelectItems;

  get companyListing() {
    return this.user.usersCompanies();
  }

  addDatasource: DatasourceNames | null = null;
  addCompany: Company | null = null;

  emitAdd() {
    if(this.addDatasource != null && this.addCompany != null) {
      const newSensor = new NotificationSensor(0, this.addDatasource, this.addCompany)
      this.$emit("at-notif-config-add-sensor", new NotificationSensorAndConfigId(this.config.id, newSensor));
    } else {
      throw new Error("Rapport og parmetre må være valgt");
    }
  }
}
